module.exports = __webpack_public_path__ + "img/bg-shem-magnezi.e8e9f38b.jpg";